import { SUCCESS, FETCH_SPEAKERS, FETCH_SPEAKER } from '../constants/actionApi';
import { UPDATE_FAV_MODEL } from '../constants/actionLocal';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';

export default (state = initialState.speakers, { type, payload }) => {
  switch (type) {
    case FETCH_SPEAKERS + SUCCESS:
    case FETCH_SPEAKER + SUCCESS:
      return addOrUpdateItemsInState(state, payload.data);
    case UPDATE_FAV_MODEL:
      if (payload.type === 'speaker') {
        return addOrUpdateItemsInState(state, payload.data);
      } else {
        return state;
      }
    default:
      return state;
  }
};
